import * as React from 'react';
import { SVGProps } from 'react';
const UncheckedCheckbox = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 20 20' fill='none'>
    <path d='M4.5 17C4.08333 17 3.72933 16.854 3.438 16.562C3.146 16.2707 3 15.9167 3 15.5V4.5C3 4.08333 3.146 3.72933 3.438 3.438C3.72933 3.146 4.08333 3 4.5 3H15.5C15.9167 3 16.2707 3.146 16.562 3.438C16.854 3.72933 17 4.08333 17 4.5V15.5C17 15.9167 16.854 16.2707 16.562 16.562C16.2707 16.854 15.9167 17 15.5 17H4.5ZM4.5 15.5H15.5V4.5H4.5V15.5Z' />
  </svg>
);
export default UncheckedCheckbox;
